// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   1. THE CELL (TD/TH)
   ========================= */
.dynamic-table th,
.dynamic-table td,
.table-cell {
  /* Dimensions */
  width: var(--col-width) !important;
  min-width: var(--col-width) !important;
  max-width: var(--col-width) !important;

  height: 28px !important; 
  
  /* Layout */
  padding: 0 !important; /* Reset padding so input fills 100% */
  margin: 0;
  position: relative;
  vertical-align: middle;
  box-sizing: border-box !important;
  
  /* Borders & Background */
  border-right: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-central);
  
  /* Text handling */
  overflow: hidden;
  white-space: nowrap;
}



/* The Select element itself inside a selected row */
.selected-row .cell-select {
  width:100%;
  background-color: rgba(188, 19, 254, 0.1) !important; 
  color: var(--text-main);
}

/* The Dropdown Options */
.cell-select option {
  /* Match your app's dark panel background */
  background-color: var(--bg-panel) !important; 
  color: var(--text-main);
  padding: 10px;
}

/* Highlighting the hovered option (Works in Chrome/Edge) */
.cell-select option:hover,
.cell-select option:focus,
.cell-select option:checked {
  background-color: rgba(188, 19, 254, 0.3) !important;
  color: #fff;
}

/* =========================
   2. INPUTS & SELECTS (The Content)
   ========================= */
/* =========================
   2. INPUTS & SELECTS (The Content)
   ========================= */
.cell-input, 
.cell-select,
.header-filter-input {
  /* THE STRETCHERS */
  flex: 1 1 !important;          /* CRITICAL: Grows to fill the Flex TD */
  width: 100% !important;      /* Backup for width */
  height: 100% !important;     /* Fill the 28px height */
  
  display: block !important;   /* Ensures it behaves as a box */
  box-sizing: border-box !important;

  /* STYLING */
  padding: 0 10px !important; 
  font-size: 13px;
  color: var(--text-main);
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  appearance: none;            /* Removes default OS arrows */
}


/* Edit Mode Highlight */
.cell-input:focus, 
.cell-select:focus {
  background: rgba(255, 255, 255, 0.05) !important;
}

/* =========================
   3. SELECTION STATES (The Glow)
   ========================= */

/* 1. The Row Background */
.selected-row td {
  background-color: rgba(188, 19, 254, 0.08) !important;
  /* REMOVE internal borders to stop the "grid" look during selection */
  border-top: none !important; 
  
  /* 2. The Single Top Line (Using Box Shadow) */
  /* This creates a 1px line at the very top of every cell in the row */
  box-shadow: inset 0 1px 0 0 var(--accent) !important; 
  
  transition: background-color 0.2s ease;
}

/* 3. The Outer Glow (Apply to the whole row or the first/last cells) */
.selected-row {
  /* This creates the soft "bloom" above the row */
  filter: drop-shadow(0 -2px 4px rgba(0, 212, 255, 0.2));
}

/* 4. The Active Cell (The Purple Box) */
/* Keep this separate so the 'Selected Cell' still has its own border */
.table-cell.selected {
  outline: 2px solid #bc13fe !important; 
  outline-offset: -2px;
  z-index: 40 !important; /* Must be higher than sticky-col (30) */
}

/* =========================
   4. ACTION BUTTONS & GROUPS
   ========================= */
.cell-btn-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 0 8px;
  height: 100%;
}

.cell-icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-dim);
  transition: color 0.2s;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.cell-icon-btn:hover {
  color: var(--accent);
}

`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Central/CentralUnitViewPort/TableCell.css"],"names":[],"mappings":"AAAA;;8BAE8B;AAC9B;;;EAGE,eAAe;EACf,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;;EAEtC,uBAAuB;;EAEvB,WAAW;EACX,qBAAqB,EAAE,sCAAsC;EAC7D,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;;EAEjC,yBAAyB;EACzB,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;;EAEnC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA,oDAAoD;AACpD;EACE,UAAU;EACV,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;AACf;;AAEA,2DAA2D;AAC3D;;;EAGE,oDAAoD;EACpD,WAAW;AACb;;AAEA;;8BAE8B;AAC9B;;8BAE8B;AAC9B;;;EAGE,mBAAmB;EACnB,oBAAkB,WAAW,wCAAwC;EACrE,sBAAsB,OAAO,qBAAqB;EAClD,uBAAuB,MAAM,yBAAyB;;EAEtD,yBAAyB,IAAI,gCAAgC;EAC7D,iCAAiC;;EAEjC,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB,aAAa,8BAA8B;AAC7D;;;AAGA,wBAAwB;AACxB;;EAEE,gDAAgD;AAClD;;AAEA;;8BAE8B;;AAE9B,0BAA0B;AAC1B;EACE,qDAAqD;EACrD,qEAAqE;EACrE,2BAA2B;;EAE3B,8CAA8C;EAC9C,qEAAqE;EACrE,oDAAoD;;EAEpD,sCAAsC;AACxC;;AAEA,uEAAuE;AACvE;EACE,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA,wCAAwC;AACxC,uEAAuE;AACvE;EACE,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB,EAAE,wCAAwC;AAClE;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* =========================\n   1. THE CELL (TD/TH)\n   ========================= */\n.dynamic-table th,\n.dynamic-table td,\n.table-cell {\n  /* Dimensions */\n  width: var(--col-width) !important;\n  min-width: var(--col-width) !important;\n  max-width: var(--col-width) !important;\n\n  height: 28px !important; \n  \n  /* Layout */\n  padding: 0 !important; /* Reset padding so input fills 100% */\n  margin: 0;\n  position: relative;\n  vertical-align: middle;\n  box-sizing: border-box !important;\n  \n  /* Borders & Background */\n  border-right: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n  background-color: var(--bg-central);\n  \n  /* Text handling */\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n\n\n/* The Select element itself inside a selected row */\n.selected-row .cell-select {\n  width:100%;\n  background-color: rgba(188, 19, 254, 0.1) !important; \n  color: var(--text-main);\n}\n\n/* The Dropdown Options */\n.cell-select option {\n  /* Match your app's dark panel background */\n  background-color: var(--bg-panel) !important; \n  color: var(--text-main);\n  padding: 10px;\n}\n\n/* Highlighting the hovered option (Works in Chrome/Edge) */\n.cell-select option:hover,\n.cell-select option:focus,\n.cell-select option:checked {\n  background-color: rgba(188, 19, 254, 0.3) !important;\n  color: #fff;\n}\n\n/* =========================\n   2. INPUTS & SELECTS (The Content)\n   ========================= */\n/* =========================\n   2. INPUTS & SELECTS (The Content)\n   ========================= */\n.cell-input, \n.cell-select,\n.header-filter-input {\n  /* THE STRETCHERS */\n  flex: 1 !important;          /* CRITICAL: Grows to fill the Flex TD */\n  width: 100% !important;      /* Backup for width */\n  height: 100% !important;     /* Fill the 28px height */\n  \n  display: block !important;   /* Ensures it behaves as a box */\n  box-sizing: border-box !important;\n\n  /* STYLING */\n  padding: 0 10px !important; \n  font-size: 13px;\n  color: var(--text-main);\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  appearance: none;            /* Removes default OS arrows */\n}\n\n\n/* Edit Mode Highlight */\n.cell-input:focus, \n.cell-select:focus {\n  background: rgba(255, 255, 255, 0.05) !important;\n}\n\n/* =========================\n   3. SELECTION STATES (The Glow)\n   ========================= */\n\n/* 1. The Row Background */\n.selected-row td {\n  background-color: rgba(188, 19, 254, 0.08) !important;\n  /* REMOVE internal borders to stop the \"grid\" look during selection */\n  border-top: none !important; \n  \n  /* 2. The Single Top Line (Using Box Shadow) */\n  /* This creates a 1px line at the very top of every cell in the row */\n  box-shadow: inset 0 1px 0 0 var(--accent) !important; \n  \n  transition: background-color 0.2s ease;\n}\n\n/* 3. The Outer Glow (Apply to the whole row or the first/last cells) */\n.selected-row {\n  /* This creates the soft \"bloom\" above the row */\n  filter: drop-shadow(0 -2px 4px rgba(0, 212, 255, 0.2));\n}\n\n/* 4. The Active Cell (The Purple Box) */\n/* Keep this separate so the 'Selected Cell' still has its own border */\n.table-cell.selected {\n  outline: 2px solid #bc13fe !important; \n  outline-offset: -2px;\n  z-index: 40 !important; /* Must be higher than sticky-col (30) */\n}\n\n/* =========================\n   4. ACTION BUTTONS & GROUPS\n   ========================= */\n.cell-btn-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  padding: 0 8px;\n  height: 100%;\n}\n\n.cell-icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text-dim);\n  transition: color 0.2s;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.cell-icon-btn:hover {\n  color: var(--accent);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
